module.exports = __webpack_public_path__ + "img/logo-dark.2fa0f670.png";